module.exports = __webpack_public_path__ + "img/0.faf9da6e.png";